import { useMemo } from "react";
import { useSelector } from "react-redux";
import { makeSelectedAssigneeIdFilterSelector } from "~/store/selectors/selector.configOptions";
import { makePeopleSelectFiltersByProjectIdSelector } from "~/store/selectors/selector.tasks";

export const useAssigneeFilterData = (projectId) => {
  const getSelectedAssigneeIds = useMemo(makeSelectedAssigneeIdFilterSelector, []);

  const getAssigneesOnProject = useMemo(makePeopleSelectFiltersByProjectIdSelector, []);

  const selected = useSelector((state) => getSelectedAssigneeIds(state, projectId));

  const availableAssignees = useSelector((state) => getAssigneesOnProject(state, projectId));

  const options = useMemo(() => {
    const result = [];

    availableAssignees.forEach((assigneeFilter) => {
      result.push({
        id: parseInt(assigneeFilter.id),
        name: `${assigneeFilter.name}`,
        additionalInfo: `(${assigneeFilter.countOpen}/${assigneeFilter.countAll})`,
      });
    });

    return result;
  }, [availableAssignees]);

  return [selected, options];
};
